// extracted by mini-css-extract-plugin
module.exports = {"grid":"payment-prompt_grid__1SDF5","card":"payment-prompt_card__9_D8Z","title":"payment-prompt_title__33vVv","buttons":"payment-prompt_buttons__19ZUe"};